import { render, staticRenderFns } from "./StaffManage.vue?vue&type=template&id=3ed5b8f4&scoped=true&"
import script from "./StaffManage.vue?vue&type=script&lang=js&"
export * from "./StaffManage.vue?vue&type=script&lang=js&"
import style0 from "./StaffManage.vue?vue&type=style&index=0&id=3ed5b8f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5b8f4",
  null
  
)

export default component.exports